import { render } from "./UserTables.vue?vue&type=template&id=1388fdf4"
import script from "./UserTables.vue?vue&type=script&lang=js"
export * from "./UserTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__